import { render } from "./FooterBlack.vue?vue&type=template&id=10b253d1"
import script from "./FooterBlack.vue?vue&type=script&lang=js"
export * from "./FooterBlack.vue?vue&type=script&lang=js"

import "./FooterBlack.vue?vue&type=style&index=0&id=10b253d1&lang=scss"

import exportComponent from "../../../../../DIARC/pixonanimation.az/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__